/* eslint-disable */
import { createVNode, render } from 'vue';
// 1. 导入组件
import popupTemp from './PopTemple.vue';
// 2. 准备一个DOM容器
const div = document.createElement('div');
div.setAttribute('class', 'popup');
document.body.appendChild(div);
let time = null;
export default (config) => {
  const clear = () => {
    render(null, div);
  };
  config.clear = clear;
  // 3. 创建虚拟dom (组件对象， props)
  const vnode = createVNode(popupTemp, { config });
  // 4. 把虚拟dom渲染到div
  render(vnode, div);
};
